<template>
  <div class="not-supported" v-if="isMobileDevice">
    <mobile-not-supported></mobile-not-supported>
  </div>
  <div class="app-wrapper" v-else>
    <metainfo>
      <template v-slot:title="{ content }">{{ content }}</template>
      <template v-slot:og(title)="{ content }">
        {{ content }} | THEOS
      </template>
    </metainfo>
    <div>
      <app-menu-bar />
    </div>
    <router-view />
    <errors />
    <app-alert></app-alert>
    <registration-modal></registration-modal>
    <app-footer v-show="user.address !== ''" />
  </div>
</template>
<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import Errors from "./components/Errors";
import { ethereumService } from "./main";
import { cardanoService } from "./main";
import useAuth from "./composables/useAuth";
import AppAlert from "@/elements/AppAlert.vue";
import AppMenuBar from "./components/AppMenuBar.vue";
import AppFooter from "./components/AppFooter.vue";
import RegistrationModal from "@/components/Registration/RegistrationModal.vue";
import { useMeta } from "vue-meta";
import MobileNotSupported from "@/components/MobileNotSupported";
import { useRouter } from "vue-router";
import useUserProfile from "@/composables/useUserProfile";
import useToast from "@/composables/useToast";

export default {
  components: {
    Errors,
    AppAlert,
    AppMenuBar,
    AppFooter,
    RegistrationModal,
    MobileNotSupported,
  },
  setup() {
    const store = useStore();
    const isMobileDevice = ref(false);
    const router = useRouter();
    const { showToast } = useToast();
    const { user } = useUserProfile(store, router);
    const handleWindowResize = () =>
      (isMobileDevice.value = window.innerWidth < 991);
    window.addEventListener("resize", handleWindowResize);
    const { meta } = useMeta({
      title: "THEOS",
    });
    onMounted(async () => {
      handleWindowResize();
      const { handleAccountChange, handleChainChange } = useAuth(
        store,
        ethereumService,
        cardanoService
      );
      await store.dispatch("contracts/fetchNetworkName");
      await cardanoService.onAccountChanged(handleAccountChange);
      await cardanoService.onChainChanged(handleChainChange);
      await store.dispatch("userProfile/fetchMe");
      const connected = await cardanoService.isProviderConnected();
      if (!connected) {
        showToast(
          "This is a beta release",
          "Code audit is on its way, usage on your own risk",
          "Beta1"
        );
        await store.dispatch("minting/commitByKey", {
          isBeginConnectionModalOpen: true,
        });
      }
    });
    return {
      user,
      meta,
      isMobileDevice,
    };
  },
};
</script>

<style>
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
